export const eventbriteConfig = {
	baseURL: `https://www.eventbriteapi.com/v3/`,
	privateToken: process.env.GATSBY_EVENTBRITE_PRIVATE_TOKEN,
	organizationId: `468887340615`,
	venueId: `52527319`,
};
